import { Link } from "react-router-dom";

import { MorphingText } from "@/components/ui/liquid-text";

const COLLEGE_NAME = "Independent College of English and Microtrainings";

const HEADER_MORPH_TEXTS = [
  COLLEGE_NAME,
  "ICEM",
  "English · B.Ed · Computer Science",
  "Chashma Mali Khel · KPK",
];

export default function Navbar() {
  return (
    <header className="fixed top-0 z-40 w-full border-b border-border/60 bg-white/90 shadow-sm backdrop-blur-md dark:bg-neutral-950/90">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-3 px-4 py-3 sm:px-6">
        <Link
          to="/"
          className="flex min-w-0 flex-1 items-center"
          aria-label={`${COLLEGE_NAME} — Home`}
        >
          <div className="flex min-w-0 flex-1 items-center gap-2.5 text-[clamp(0.8125rem,1.35vw+0.45rem,1.25rem)] font-semibold leading-none tracking-tight text-indigo-950 dark:text-indigo-100 sm:gap-3">
            <img
              src="images/icem-logo.png"
              alt=""
              className="h-[1em] w-[1em] shrink-0 rounded-[10px] object-contain bg-white p-0.5 shadow-md ring-2 ring-indigo-200/90 ring-offset-2 ring-offset-white dark:ring-indigo-400/30 dark:ring-offset-neutral-950"
            />
            <MorphingText texts={HEADER_MORPH_TEXTS} className="min-w-0" title={COLLEGE_NAME} />
          </div>
        </Link>
      </div>
    </header>
  );
}
